<template>
  <div class="card-extras" v-if="ticket && ticket.package_options.length > 0">
    <div v-for="(option, index) in ticket.package_options" :class="'card'">

      <div class="card-header hg-underline" :style="underlineOverride">
        <strong>{{option.title}}</strong>
      </div>
      <div class="card-body">
        <b-form-group size="medium">
          <b-radio-group style="padding-top: 10px;" stacked value-field="id" text-field="title" v-model="optionsSelected[index]" :name="'subOption_' + ticket.id + '_' + attendeeIndex + '_' + index" @change="updateTicket" :options="option.package_sub_options">
          </b-radio-group>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["ticket", "attendee", "attendeeIndex"],

  data: function() {
    return {
      columnSize: "col-4",
      optionsSelected: [],
      event: this.$store.getters.getEvent
    };
  },

  computed: {
    underlineOverride() {
      return {
        borderBottom: "4px solid " + this.event.phcolour
      };
    }
  },

  created() {
    if (
      this.attendee.registered_user_attributes &&
      this.attendee.registered_user_attributes.menu_options_selected
    ) {
      this.optionsSelected = this.attendee.registered_user_attributes.menu_options_selected;
    }

    if (
      !this.ticket.package_options ||
      this.ticket.package_options.length == 1
    ) {
      this.columnSize = "col-12";
    } else if (this.ticket.package_options.length == 2) {
      this.columnSize = "col-6";
    }
  },

  methods: {
    updateTicket() {
      this.attendee.registered_user_attributes.menu_options_selected = this.optionsSelected;
    }
  }
};
</script>
